module.exports = __webpack_public_path__ + "static/img_15-c5eb09df0e91f4c5711b502d0333f9e5.png";